import { useState, useEffect, useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as _ from 'lodash';
import axios from 'axios';
import FireStoreParser from 'firestore-parser';
import { DataContext } from '../context/data-context';
import { useTeamLogos } from './team';

export const getLeadersWithTopListNumber = (leadersNoToplistNumber) => {
  const groupedLeaders = _.groupBy(leadersNoToplistNumber, 'stat');

  const keys = Object.keys(groupedLeaders).sort((a, b) => b - a);

  keys.forEach((key, index) => {
    groupedLeaders[key].forEach((leader) => {
      if (index === 0) {
        // eslint-disable-next-line no-param-reassign
        leader.topListNumber = 1;
      }

      const previousIndexes = Array.from(
        { length: index - 0 },
        (a, i) => 0 + i
      );
      // eslint-disable-next-line no-shadow
      const filteredKey = keys.filter((k, index) =>
        previousIndexes.includes(index)
      );
      const previousLeaders = filteredKey.map((k) => groupedLeaders[k]).flat();
      const topListNumber = previousLeaders.length + 1;

      // eslint-disable-next-line no-param-reassign
      leader.topListNumber = topListNumber;
    });
  });

  const leaders = keys.map((key) => groupedLeaders[key]);
  return leaders.flat();
};

export const useLeaders = (type, limit = 10) => {
  const { endpointUrl } = useContext(DataContext);
  const [teamLogos, loadingLogos, errorLogos] = useTeamLogos();
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${endpointUrl}data-endpoint/leaders`)
      .then((response) => {
        setData(FireStoreParser(response.data)?.fields);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [endpointUrl, setData]);

  const leaders =
    !loading && !error ? getLeadersWithTopListNumber(data[type]) : null;
  const list = leaders?.slice(0, limit).map((leader) => {
    const logo = _.get(teamLogos, leader.player.teamAbbrv, '');
    return {
      ...leader.player,
      stat: leader.stat,
      matches: leader.matches,
      topListNumber: leader.topListNumber,
      logoImageUrl: logo?.logoImageUrl,
    };
  });

  return [list, loading, error];
};

export function useLeadersInTeam(abbrv) {
  const { endpointUrl } = useContext(DataContext);
  const [teamLogos, loadingLogos, errorLogos] = useTeamLogos();
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${endpointUrl}data-endpoint/leaders-in-team?id=${abbrv}`)
      .then((response) => {
        setData(FireStoreParser(response.data)?.fields);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [endpointUrl, setData]);

  return [data, loading, error];
}
